export const AdminRole = {
  ADMIN: "Admin",
  ACCOUNTING: "Accounting",
  USER: "User",
};
